export const GRAVING_MAX_HEIGHT = 0.02;

export const MAX_BRIGHTNESS = 2.0;
export const MIN_BRIGHTNESS = 0.0;
export const BRIGHTNESS_STEP = (MAX_BRIGHTNESS - MIN_BRIGHTNESS) / 10.0;
export const DEFAULT_BRIGHTNESS = 1.5;

export const MAX_CONTRAST = 5.0;
export const MIN_CONTRAST = 1.0;
export const CONTRAST_STEP = (MAX_CONTRAST - MIN_CONTRAST) / 10.0;
export const DEFAULT_CONTRAST = 1.0;

export const MAX_ZOOM = 2.0;

export function minPositions(zoom, innerAspectRatio, imageAspectRatio) {
  const frameWidth = 1.0;
  const frameHeight = frameWidth / innerAspectRatio;
  const imageWidth = frameWidth * zoom;
  const imageHeight = imageWidth / imageAspectRatio;

  const minY = (frameHeight - imageHeight) * innerAspectRatio * imageAspectRatio;
  const minX = frameWidth - imageWidth;

  return {
    x: minX,
    y: minY,
  };
}

export function minZoom(innerAspectRatio, imageAspectRatio) {
  const frameWidth = 1.0;
  const frameHeight = frameWidth / innerAspectRatio;
  const imageWidth = frameWidth;
  const imageHeight = imageWidth / imageAspectRatio;

  return Math.max(frameHeight / imageHeight, 1.0);
}

export function updateActiveImage(state, update) {
  return {
    ...state,
    items: state.items.map((item, index) => (
      index === state.active
        ? {
          ...item,
          ...(typeof update === 'function' ? update(item) : update),
        }
        : item
    )),
  };
}

export const DEFAULT_WIDTH = 14.5;
export const DEFAULT_HEIGHT = 10.3;
export const DEFAULT_ASPECT_RATIO = DEFAULT_WIDTH / DEFAULT_HEIGHT;

export const DEFAULT_BORDER_WIDTH = 0.4;
export const DEFAULT_BORDER = DEFAULT_BORDER_WIDTH / DEFAULT_HEIGHT;

export const innerAspectRatio = (width, height) => (
  (width - 2.0 * DEFAULT_BORDER_WIDTH) / (height - 2.0 * DEFAULT_BORDER_WIDTH)
);
